import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-destructive/5 via-background to-background" />
      
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative z-10 w-full max-w-lg text-center space-y-8"
      >
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-destructive/20 blur-xl rounded-full" />
            <div className="relative p-6 bg-background rounded-full border-2 border-destructive/10 shadow-xl">
              <ShieldAlert className="h-16 w-16 text-destructive" />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl font-bold tracking-tight">Access Denied</h1>
          <p className="text-lg text-muted-foreground max-w-sm mx-auto">
            You don't have permission to access this area. Please contact your administrator if you believe this is a mistake.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button 
            variant="outline" 
            size="lg"
            className="w-full sm:w-auto min-w-[140px]"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
          <Button 
            size="lg"
            className="w-full sm:w-auto min-w-[140px] bg-gradient-to-r from-primary to-primary-glow"
            onClick={() => navigate('/app/dashboard')}
          >
            <Home className="h-4 w-4 mr-2" />
            Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default AccessDeniedPage;
